<template>
  <main class="main profile-page sell-offers-page page-inside">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div
            :class="[
              'title',
              'big',
              { 'error-title': isFailure, success: !isFailure },
            ]"
          >
            {{ title }}
          </div>
          <div :class="['desc', { 'error-desc': isFailure }]">
            {{ description }}
          </div>

          <div class="actions">
            <RouterLink :to="{ name: 'SellOffers' }">
              <button class="button">
                <span>{{ isFailure ? "Try again" : "My offers" }}</span>
              </button>
            </RouterLink>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "PayoutResultPage",
  props: {
    status: {
      type: String,
      required: true,
      validator: (value) => ["success", "failure"].includes(value),
    },
    message: {
      type: String,
      default: "",
    },
  },
  computed: {
    isFailure() {
      return this.status === "failure";
    },
    title() {
      return this.isFailure
        ? "Payout Request Failed."
        : "Your Payout Request Has Been Submitted.";
    },
    description() {
      if (this.message) {
        return this.message;
      }
      return this.isFailure
        ? "Sorry, something went wrong while processing your payout. Please try again later or contact " +
            this.supportEmail
        : "Your funds will be transferred to your bank account shortly.";
    },
    supportEmail() {
      if (this.$parent.footerSupportEmail) {
        return this.$parent.footerSupportEmail;
      }
      return null;
    },
  },
};
</script>

<style scoped>
.page-inside .hero-section .wrapper > .title {
  margin-bottom: 20px;
}

.desc {
  margin-bottom: 20px;
}

.error-title {
  color: #dc3545;
}

.success {
  color: #0cbe19;
}

.error-desc {
  color: #6c757d;
}

.actions {
  display: flex;
  justify-content: center;
}
</style>
